<template>
  <div class="employee-tab-inner leave-align-mobile" >
    <div class="row">
      <div class="col-md-12 pr-0">
        <div class="clearfix company-form-container leave-log mb-3">
          <div class="py-3 employee-investment-wrapper">
            <div class=" px-3" >
              <div class="row no-gutters mb-3">
                <div class="col-sm-12 company-form-box-title pb-3">
                  Leave Log
                </div>
                <div class="col-md-12 leave-log-wrapper w-100">
                  <roster-ess-leave-log  :flg="1" :key="componentKey"></roster-ess-leave-log>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>

export default {
  data() {
    return {
      componentKey: 0,
      leave_limit: '',
      leave_attendance_report: [],
    }
  },
  methods: {
    getLeaveAttendanceReport: function () {
      if (!this.checkNet()) return false;

      axios.get(this.$api_url + '/front/leave-attendance/leave/attendances/report/fiscalyear').then(function (response) {
        this.leave_attendance_report = response.data;
      }.bind(this));
    },
  },
  created: function () {
    this.getLeaveAttendanceReport();
  },
}
</script>